import React from 'react';
import classNames from 'classnames/bind';

import { Image } from '@thd-olt-component-react/image';
import { CountdownTimer } from '@thd-olt-component-react/countdown-timer';

import { useSpecialBuy } from '../../context/SpecialBuyProvider';
import { SpecialBuyNavButton } from '../SpecialBuyNavButton/SpecialBuyNavButton';
import styles from './special-buy-header.module.scss';

const cNames = classNames.bind(styles);
const SpecialBuyHeader = () => {
  const {
    endDate,
    startDate,
    logoSrc,
    tagline,
    specialBuyType,
    isFallbackBanner,
    isCondensedLayout,
    isSpecialBuyDataLoading,
  } = useSpecialBuy();
  const isSbotd = specialBuyType === 'sbotd';

  let subTextMessage;
  if (isFallbackBanner && !isSpecialBuyDataLoading) {
    const endTimeText = isSbotd ? <>Today</> : <>This&nbsp;Week</>;
    subTextMessage = (
      <>
        Browse&nbsp;All Departments, Savings&nbsp;End {endTimeText}!
      </>
    );
  } else {
    subTextMessage = isSbotd
      ? <>Today&nbsp;Only! Free&nbsp;Delivery</>
      : <>Online&nbsp;Only&nbsp;+ Free&nbsp;Delivery</>;
  }

  const headerClassNames = cNames('header', {
    'header--condensed': isCondensedLayout,
  });

  const taglineClassNames = cNames(
    'message__tagline',
    'u__display-font--black',
    {
      u__xlarge: !isCondensedLayout,
      u__husky: isCondensedLayout,
    },
  );

  const subTextClassNames = cNames('message__sub-text',
    { u__medium: !isCondensedLayout },
  );

  // this confusing code is a work around for an upstream quirk.
  // a story to work out the quirk has been created. Then this will need to be cleaned up
  const consistentEndDate = isSbotd
    ? startDate
    : endDate;

  return (
    <section className={headerClassNames}>
      <Image
        asset={logoSrc}
        alt="Special Buy Logo"
        title="Special Buy Logo"
        className={cNames('logo')}
        width={1}
        height={1}
      />
      <div className={cNames('message')}>
        <h3 className={taglineClassNames}>
          {tagline}
        </h3>
        <span className={subTextClassNames}>
          <span>{subTextMessage}</span>
          {(!isFallbackBanner && consistentEndDate?.length) && (
            <span className={cNames('banner-timer')}>
              <span className={cNames('banner-timer__prefix')}>
                Ends&nbsp;in{' '}
              </span>
              <CountdownTimer
                isPromotionTimer
                endDate={consistentEndDate}
                isSBOTD={isSbotd}
              />
            </span>
          )}
        </span>
      </div>
      {!isCondensedLayout && <SpecialBuyNavButton />}
    </section>
  );
};

SpecialBuyHeader.displayName = 'SpecialBuyHeader';

export { SpecialBuyHeader };
